import React from 'react';

import I18n from '../../../lib/i18n';
import ListImage from './ListImage';
import NewsText from './NewsText';

interface IProps {
  listImage: string;
  text: string;
  iconImage: string;
  movie: number;
}

const NewsListItem = (props: IProps) => {
  const { listImage, text, iconImage, movie } = props;

  return (
    <div>
      <h4>{I18n.t('messages.preview.news_list_item')}</h4>
      <div className="news-list-item list-image-preview">
        <ListImage listImage={listImage} movie={movie} />
        <div className="news-list-item-title">
          <div className="list-news-icon-box">
            <img
              role="presentation"
              className="list-news-icon"
              src={`data:image/jpeg;base64,${iconImage}`}
            />
          </div>
          <NewsText className={'news-list-item-text'} text={text}/>
        </div>
      </div>
    </div>
  );
};

export default NewsListItem;